import { isNull, isUndefined } from 'lodash';
import React, { useRef } from 'react';
import { SliderInput } from '@meitu/saas-ui';
import { getLayerCenterPoint } from '@meitu/saas-editor-core/es/utils/layer-kit';
import { IBrushLayerProps, ILayerProps, IPoint } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@meitu/saas-editor-ui/es/components/label-action';
import { useListenActivePickLayerProps } from '@meitu/saas-editor-ui/es/hooks/use-listen-layer-props';
import { useLocaleStore } from '@/i18n';
import { editor } from '@/instance';

export const WidthFeature: React.FC<{
    id?: string;
    width?: number;
    isStroke: boolean;
    maxValue?: number;
    minValue?: number;
    onAfterChange?: Function;
    onChange?: Function;
    style?: React.CSSProperties;
}> = React.memo(({ style, id, width, isStroke, maxValue = 100, minValue = 0, onAfterChange, onChange }) => {
    const { $t } = useLocaleStore();
    const needListener = !isUndefined(id);
    const oldLayer = useRef<ILayerProps | null>(null);
    const centerPoint = useRef<IPoint | null>(null);

    const res = useListenActivePickLayerProps(
        editor,
        (layer) => {
            if (!layer) return null;
            const { fills, stroke } = layer.data as IBrushLayerProps;
            if (isStroke) {
                return stroke.width;
            }
            return fills[0].width;
        },
        true,
        needListener,
    );

    if (needListener) {
        if (isNull(res)) {
            return null;
        }
        width = res;
    } else {
        if (isUndefined(width)) return null;
    }

    return (
        <div className="c-brush-panel__item c-brush-panel__item-width" style={{ ...style }}>
            <LabelAction title={$t((v) => v.panel.brushPanel.thickness)} align={true}>
                <div style={{ width: 174 }}>
                    <SliderInput
                        value={width}
                        max={maxValue}
                        min={minValue}
                        showStepBtn={true}
                        type="horizontal"
                        onChange={(val: number) => {
                            if (id) {
                                if (oldLayer.current === null) {
                                    const layer = editor.services.flatLayer.getLayer(id, true);
                                    oldLayer.current = layer;
                                    centerPoint.current = getLayerCenterPoint(layer);
                                }
                                if (centerPoint.current) {
                                    editor.brushLayer.setWidth(id, val, centerPoint.current, isStroke);
                                }
                            }
                            onChange?.(val);
                        }}
                        onAfterChange={(val: number) => {
                            if (id) {
                                if (!isNull(oldLayer.current) && centerPoint.current) {
                                    editor.brushLayer.setWidth(
                                        id,
                                        val,
                                        centerPoint.current,
                                        isStroke,
                                        oldLayer.current,
                                    );
                                }
                                oldLayer.current = null;
                            }
                            onAfterChange?.(isStroke ? 19 : 77, val);
                        }}
                    />
                </div>
            </LabelAction>
        </div>
    );
});
